<div
  class="skyclub-tracker__card"
  *ngFor="let card of content; let i = index"
  [attr.data-cy]="'skyclub-spend-tracker-card-visits-available-card-' + (i + 1)"
>
  <ng-container *ngIf="i === carouselIndex">
    <div
      class="skyclub-tracker__card__content {{
        card.thresholdMet ? 'threshold-met-content' : ''
      }}"
    >
      <div
        class="skyclub-tracker__card__content__visit  {{
          card.thresholdMet ? 'threshold-met-visit' : ''
        }} {{ card.visit.count && card.visit.count !== 0 ? '' : 'no-count' }} {{
          card.visit.count !== undefined && card.visit.count === 0
            ? 'zero-visits'
            : ''
        }}"
        [ngStyle]="{ 'background-image': 'url(' + card.visit.image?.src + ')' }"
        role="status"
        [attr.aria-label]="
          (card.visit.count || 0) +
          ' visits available with your ' +
          card.type.name
        "
      >
        <div
          class="skyclub-tracker__card__content__visit__count"
          [style.--progress]="progressValue"
          *ngIf="card.visit.count && card.visit.count !== 0"
        >
          <span
            class="skyclub-tracker__card__content__visit__count-value"
            [innerHTML]="card.visit.count"
            data-cy="skyclub-spend-tracker-card-visits-available-number"
          ></span>
        </div>
        <div
          class="skyclub-tracker__card__content__visit-title {{
            card.visit.count !== undefined && card.visit.count === 0
              ? 'zero-visits-title'
              : ''
          }}"
          [innerHTML]="card.visit.title"
          data-cy="skyclub-spend-tracker-card-visits-available-text"
        ></div>
        <div
          class="skyclub-tracker__card__content__visit-description {{
            card.visit.count !== undefined && card.visit.count === 0
              ? 'zero-visits-description'
              : ''
          }}"
          *ngIf="card.visit.description"
          [innerHTML]="card.visit.description"
          data-cy="skyclub-spend-tracker-card-visits-available-description"
        ></div>
      </div>
      <div
        class="skyclub-tracker__card__content__type"
        data-cy="skyclub-spend-tracker-card-description"
      >
        <span
          class="skyclub-tracker__card__content__type-name"
          [innerHTML]="card.type.name"
          data-cy="skyclub-spend-tracker-card-type-label"
        ></span>
        <span
          class="skyclub-tracker__card__content__type-label"
          *ngIf="card.type.terms.url"
        >
          <a
            [innerHTML]="card.type.terms.label"
            [href]="card.type.terms.url"
            target="_blank"
            (click)="onTermsLinkClick(card, i, 'link')"
          ></a>
        </span>
        <button
          [id]="'skyclub-tracker__card__content__type-tooltip--' + i"
          auraTooltip
          *ngIf="card.type.terms.information"
          [tooltipContent]="{
            position: 'bottom-right',
            trapFocus: true,
            hideCloseIcon: false,
            color: '#0b1f66',
            info: card.type.terms.information
          }"
          class="skyclub-tracker__card__content__type-icon"
          [attr.aria-label]="card.type.name + ' help icon' || ''"
          [attr.aria-describedby]="'spend-tracker-card-tooltip'"
          [attr.data-cy]="'skyclub-spend-tracker-card-tooltip-' + (i + 1)"
          role="button"
          (click)="onTermsLinkClick(card, i, 'tooltip')"
        >
          <img alt="Info Icon" role="img" />
        </button>
      </div>
    </div>
    <div
      class="skyclub-tracker__card__footer-wrapper"
      [class.footer-threshold-met]="content[i].spendTracker?.thresholdMet"
      role="complementary"
      [attr.aria-label]="
        content[i].spendTracker
          ? 'Spend tracker information'
          : 'Sky Club search information'
      "
    >
      <idp-skyclub-spend-tracker-footer
        *ngIf="content[i].spendTracker || content[i].searchEligibleFooter"
        class="sky-club-tracker__card__spend-tracker-footer"
        [content]="content[i].spendTracker || content[i].searchEligibleFooter!"
        (searchEligibleClick)="
          onSearchEligibleClick(
            $event,
            i,
            content[i].spendTracker || content[i].searchEligibleFooter
          )
        "
      ></idp-skyclub-spend-tracker-footer>
    </div>
  </ng-container>
</div>
